import React from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import AdminDashboard from "./pages/AdminDashboard";

import Cookies from "js-cookie";

import Login from "./pages/Login";

import ShowUsers from "./pages/ShowUsers";

import AddUser from "./pages/AddUser";

import EditUserAccess from "./pages/EditUserAccess";

import DeleteUser from "./pages/DeleteUser";

import Countries from "./pages/Countries";

import AddCountry from "./pages/AddCountry";

import UpdateCountry from "./pages/UpdateCountry";

import DeleteCountry from "./pages/DeleteCountry";

import ShowLeads from "./pages/ShowLeads";

import UploadLeads from "./pages/UploadLeads";

import UpdateLead from "./pages/UpdateLead";

import DeleteLead from "./pages/DeleteLead";

import AllLeads from "./pages/AllLeads";

import UpdateProfile from "./pages/UpdateProfile";

import Emails from "./pages/emails/Emails";

import ValidateEmails from "./pages/emails/ValidateEmails";

import SendEmails from "./pages/emails/SendEmails";

import CheckEmails from "./pages/emails/CheckEmails";

import AddEmail from "./pages/emails/AddEmail";

import DeleteEmail from "./pages/emails/DeleteEmail";

import EmailTemplates from "./pages/emails/EmailTemplates";

import AddTemplate from "./pages/emails/AddTemplate";

import DeleteTemplate from "./pages/emails/DeleteTemplate";

import EditTemplate from "./pages/emails/EditTemplate";

import IncomingMail from "./pages/emails/IncomingMail";

import FollowUps from "./pages/FollowUps";

import SmsHub from "./pages/sms/SmsHub";
import SmsTemplates from "./pages/sms/SmsTemplates";
import AddSmsTemplate from "./pages/sms/AddSmsTemplate";
import EditSmsTemplate from "./pages/sms/EditSmsTemplate";
import DeleteSmsTemplate from "./pages/sms/DeleteSmsTemplate";
import SendSms from "./pages/sms/SendSms";
import ReceivedSms from "./pages/sms/ReceivedSms";

import CountryResourcePage from "./pages/countryResources/CountryResourcePage";

import {
    hasAnyEmailAccess,
    hasFullAccess,
    canUseEmailSender,
    canUseEmailValidator,
    canManageFollowUps,
    canCreateEmailAccounts,
    canSendSms,
    canReceiveSms,
    hasAnySmsAccess,
} from "./utils/userAccess";

function App() {
    const getUsername = Cookies.get("username");
    const getRole = Cookies.get("user_role");

    const isAdmin = hasFullAccess();
    const canEmail = hasAnyEmailAccess();
    const canSender = canUseEmailSender() && canEmail;
    const canValidator = canUseEmailValidator();
    const canFollowUps = canManageFollowUps();
    const canAddEmail = canCreateEmailAccounts();
    const canSmsSend = canSendSms();
    const canSmsReceive = canReceiveSms();
    const showSms = hasAnySmsAccess();

    return (
        <div>
            {getUsername ? (
                <Routes>
                    <Route path="/" element={<AdminDashboard />}></Route>

                    <Route path="/leads/:country" element={<ShowLeads />}></Route>

                    <Route
                        path="/resources/:country/:resourceType"
                        element={<CountryResourcePage />}
                    ></Route>

                    <Route path="/updateprofile" element={<UpdateProfile />}></Route>

                    {(isAdmin || canEmail) && (
                        <>
                            <Route path="/incoming-emails" element={<IncomingMail />}></Route>
                            <Route
                                path="/incoming-emails/:country"
                                element={<IncomingMail />}
                            ></Route>
                        </>
                    )}

                    {(isAdmin || canSender) && (
                        <Route path="/emails/email-sender" element={<SendEmails />}></Route>
                    )}

                    {(isAdmin || canValidator) && (
                        <Route path="/emails/validate-emails" element={<ValidateEmails />}></Route>
                    )}

                    {(isAdmin || canFollowUps) && (
                        <Route path="/follow-ups" element={<FollowUps />}></Route>
                    )}

                    {getRole === "Administrator" && (
                        <>
                            <Route path="/users" element={<ShowUsers />}></Route>
                            <Route path="/adduser" element={<AddUser />}></Route>
                            <Route path="/edituser/:id" element={<EditUserAccess />}></Route>
                            <Route path="/deleteuser/:id" element={<DeleteUser />}></Route>
                            <Route path="/countries" element={<Countries />}></Route>
                            <Route path="/addcountry" element={<AddCountry />}></Route>
                            <Route path="/updatecountry/:id" element={<UpdateCountry />}></Route>
                            <Route path="/deletecountry/:id" element={<DeleteCountry />}></Route>
                            <Route path="/uploadleads" element={<UploadLeads />}></Route>
                            <Route path="/updatelead/:id" element={<UpdateLead />}></Route>
                            <Route path="/deletelead/:id" element={<DeleteLead />}></Route>
                            <Route path="/allleads" element={<AllLeads />}></Route>
                            <Route path="/emails" element={<Emails />}></Route>
                            <Route path="/emails/check-emails" element={<CheckEmails />}></Route>
                            <Route path="/emails/received-emails" element={<IncomingMail />}></Route>
                            <Route path="/emails/deleteemail/:id" element={<DeleteEmail />}></Route>
                            <Route path="/emails/email-templates/" element={<EmailTemplates />}></Route>
                            <Route path="/emails/addtemplate/" element={<AddTemplate />}></Route>
                            <Route path="/emails/deletetemplate/:id" element={<DeleteTemplate />}></Route>
                            <Route path="/emails/updatetemplate/:id" element={<EditTemplate />}></Route>
                        </>
                    )}

                    {(isAdmin || canAddEmail) && (
                        <Route path="/emails/addemail" element={<AddEmail />}></Route>
                    )}

                    {(isAdmin || canSmsSend) && (
                        <Route path="/sms/send" element={<SendSms />}></Route>
                    )}

                    {(isAdmin || canSmsReceive) && (
                        <Route path="/sms/received" element={<ReceivedSms />}></Route>
                    )}

                    {isAdmin && (
                        <>
                            <Route path="/sms" element={<SmsHub />}></Route>
                            <Route path="/sms/templates" element={<SmsTemplates />}></Route>
                            <Route path="/sms/addtemplate" element={<AddSmsTemplate />}></Route>
                            <Route path="/sms/updatetemplate/:id" element={<EditSmsTemplate />}></Route>
                            <Route path="/sms/deletetemplate/:id" element={<DeleteSmsTemplate />}></Route>
                        </>
                    )}
                </Routes>
            ) : (
                <Login />
            )}
        </div>
    );
}

export default App;
